import { Flex } from '@ifood/pomodoro-components';
import React from 'react';

import { Collection, Icon, Link, Name, Title } from './styles';

type PropTypes = {
  name: string;
  version: string;
  img: string;
  bg: string;
  href: string;
};

const CollectionLink = ({ name, version, img, bg, href }: PropTypes): JSX.Element => (
  <Link href={href} download>
    <Collection style={{ backgroundColor: bg }}>
      <Icon src={img} alt={name} />
      <Flex flexDirection="column">
        <Title>Collection</Title>
        <Name>
          {name} {version}
        </Name>
      </Flex>
    </Collection>
  </Link>
);

export default CollectionLink;
